import { IMediaWithContent } from '@/graphql/__generated__/global/types';
import classNames from '@/lib/classNames';
import { TRACKING_EVENT, track } from '@/lib/gtm';
import Button from '../Button';
import { CardDescription, CardTitle } from '../Card';
import { LinkRenderer, findHref, isValidLink } from '../Link';
import { ResponsiveImage } from '../ResponsiveImage';
import { ResponsiveVideo } from '../ResponsiveVideo';
import RichText from '../RichText';

export const MediaWithContent = ({ title, description, link, image, video, mediaAlignment }: IMediaWithContent) => {
    const validLink = isValidLink(link?.linkToPage, link?.linkToStory, link?.linkToExternalPage);
    const href = validLink && findHref(link?.linkToPage, link?.linkToStory, link?.linkToExternalPage);

    return (
        <div className={classNames('relative md:flex space-y-5 md:space-y-0 md:space-x-5 py-16', mediaAlignment === 'right' ? 'md:flex-row-reverse' : 'md:flex-row')}>
            {image?.data || video?.data ? (
                <div className={classNames('w-full md:grow rounded-3xl overflow-hidden')}>
                    {video?.data ? (
                        <ResponsiveVideo video={video} aspectRatio={820 / 600} />
                    ) : (
                        <ResponsiveImage src={image?.data?.attributes?.url ?? ''} alt={image?.data?.attributes?.alternativeText ?? ''} aspectRatio={820 / 600} />
                    )}
                </div>
            ) : null}
            <div className={classNames('flex flex-col justify-center p-7 w-full max-w-[540px]')}>
                {title && <CardTitle>{title}</CardTitle>}
                {description && (
                    <CardDescription>
                        <RichText content={description as string} className={classNames('mx-0')} />
                    </CardDescription>
                )}
                {link && (
                    <LinkRenderer {...link}>
                        <Button
                            className="mt-8"
                            size="lg"
                            onClick={() =>
                                track(TRACKING_EVENT.PRESSED_BUTTON, {
                                    label: link?.label,
                                    url: href ? href : '',
                                })
                            }
                        >
                            {link.label}
                        </Button>
                    </LinkRenderer>
                )}
            </div>
        </div>
    );
};
